import { useEffect, useState, useMemo } from 'react'

/**
 * This will return when a particular element is on the screen ( viewable )
 * @export
 * @param {*} ref
 * @returns {*}
 */
export default function useOnScreen(ref) {
  if (typeof IntersectionObserver === 'function') {
    const [isIntersecting, setIntersecting] = useState(false)
    /** @type {*} */
    const observer = useMemo(() => new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting)), [ref])

    useEffect(() => {
      observer.observe(ref.current)
      return () => observer.disconnect()
    }, [])

    return isIntersecting
  }
}
